import { FC, useState } from 'react';
import { Select, Form } from 'antd';
import { FormContentLayout } from '../FormContentLayout';
// import 'antd/dist/antd.css';
import styles from './index.module.css';
import { EddLayout } from '../EddLayout';
import { CARRIER_FORM_NAME, EddSteps, SERVICE_FORM_NAME } from '../../constants';
import { ButtonPair } from '../ButtonPair';

const NON_SHIPPING_DAYS_TITLE = 'What is your most commonly used shipping method?';
const NON_SHIPPING_DAYS_DESCRIPTION = 'Help our algorithm learn and predict your shipping time more accurately.';

interface ShippingMethodProps {
  methodOptions: Record<string, string[]>;
}

const ShippingMethod: FC<ShippingMethodProps> = ({ methodOptions }) => {
  const form = Form.useFormInstance();
  const firstSelectOptions = Object.keys(methodOptions).map((item) => ({ value: item }));
  const [firstSelectValue, setFirstSelectValue] = useState(form.getFieldValue(CARRIER_FORM_NAME));
  const [secondSelectValue, setSecondSelectValue] = useState(form.getFieldValue(SERVICE_FORM_NAME));
  const [secondSelectOptions, setSecondSelectOptions] = useState<{ value: string }[]>([]);

  const handleFirstSelectChange = (data: string) => {
    setFirstSelectValue(data);
    form.setFieldValue(CARRIER_FORM_NAME, data);
    /** 二级联动 */
    if (data) {
      const newSecondSelectOptions = methodOptions[data].map((item) => ({ value: item }));
      const newSecondSelectValue = newSecondSelectOptions[0]?.value;
      setSecondSelectOptions(newSecondSelectOptions);
      setSecondSelectValue(newSecondSelectValue);
      form.setFieldValue(SERVICE_FORM_NAME, newSecondSelectValue);
    } else {
      setSecondSelectOptions([]);
      setSecondSelectValue(undefined);
      form.setFieldValue(SERVICE_FORM_NAME, undefined);
    }
  };

  const handleSecondSelectChange = (data: string) => {
    setSecondSelectValue(data);
    form.setFieldValue(SERVICE_FORM_NAME, data);
  };

  return (
    <EddLayout
      left={(
        <FormContentLayout
          title={NON_SHIPPING_DAYS_TITLE}
          description={NON_SHIPPING_DAYS_DESCRIPTION}
          step={EddSteps.FOURTH}
        >
          <div className={styles.shippingMethod}>
            <Select
              className={styles.firstSelect}
              options={firstSelectOptions}
              value={firstSelectValue}
              onChange={handleFirstSelectChange}
              placeholder="Select carrier"
              allowClear
            />
            <Select
              className={styles.secondSelect}
              options={secondSelectOptions}
              value={secondSelectValue}
              onChange={handleSecondSelectChange}
              placeholder="Select service"
              allowClear
            />
          </div>
          <div className={styles.contactSupport}>
            {/* TODO: 这里 contact support 链接 */}
            If you are using other shipping methods, please contact support.
          </div>
          <ButtonPair
            step={EddSteps.FOURTH}
            disableNext={!firstSelectValue || !secondSelectValue}
          />
        </FormContentLayout>
      )}
    />
  );
};

export { ShippingMethod };
